<template>
  <v-app id="app">
    <app-navigation v-if="!hideAppUI"></app-navigation>
    <v-main>
      <router-view></router-view>
    </v-main>
    <app-footer v-if="!hideAppUI" />
    <tos-screen v-if="$store.state.tosScreen.show" />
    <app-promotion-banner />
    <friend-invite-redeem-dialog />
    <pwa-updated-notification v-if="addPWAUpdatedNotification" />
    <build-timestamp />
    <voucher-dialog
      v-if="$store.state.activeVoucherDialog.show"
      :bounty="$store.state.activeVoucherDialog.bounty"
      :showVoucherDialog="$store.state.activeVoucherDialog.show"
      @finish-pressed="voucherDialogPressed"
    />
  </v-app>
</template>

<script>
import {mapGetters, mapActions} from 'vuex'
import IdleJs from 'idle-js'
import AppNavigation from '@/components/AppNavigation'
import TOSScreen from "@/components/TOSScreen"
import BuildTimestamp from "@/components/utils/BuildTimestamp"
import PwaUpdatedNotification from "@/components/utils/PwaUpdatedNotification"
import AppFooter from "@/components/AppFooter"
import AppPromotionBanner from '@/components/promotion/AppPromotionBanner'
import VoucherDialog from '@/components/bounty/VoucherDialog'
import FriendInviteRedeemDialog from "@/components/promotion/FriendInviteRedeemDialog"
import '@/assets/scss/styles.scss'

export default {
  name: 'App',
  components: {
    AppNavigation,
    'tos-screen': TOSScreen,
    BuildTimestamp,
    PwaUpdatedNotification,
    AppFooter,
    AppPromotionBanner,
    FriendInviteRedeemDialog,
    VoucherDialog
  },
  data() {
    return {
      autoLogoutObserver: null
    }
  },
  computed: {
    ...mapGetters([
      'hideAppUI',
      'autoLogout',
      'isAuthenticated'
    ]),
    addPWAUpdatedNotification() {
      return window.matchMedia('(display-mode: standalone)').matches
    }
  },
  watch: {
    autoLogout(newValue) {
      if (newValue) {
        this.tryStartAutoLogoutObserver()
      }
    }
  },
  mounted() {
    this.tryStartAutoLogoutObserver()
  },
  methods: {
    ...mapActions([
      'userSignOut',
      'showPushNotificationRequest',
      'removeActiveVoucherDialog',
      'fetchRewardsData'
    ]),
    showPushNotificationRequest() {
      if (this.$router.currentRoute.name === 'home') {
        this.showPushNotificationRequest(true)
      }
    },
    async voucherDialogPressed() {
      await this.fetchRewardsData()
      this.removeActiveVoucherDialog(null)
    },
    tryStartAutoLogoutObserver() {
      if (this.isAuthenticated && this.autoLogout) {
        if (!this.autoLogoutObserver) {
          this.autoLogoutObserver = new IdleJs({
            idle: this.autoLogout,
            onIdle: this.runAutoLogout,
            onActive: this.resetAutoLogout
          })
        }
        this.autoLogoutObserver.start()
      }
    },
    runAutoLogout() {
      if (this.autoLogoutObserver) {
        this.autoLogoutObserver.stop()
      }

      if (this.isAuthenticated) {
        this.userSignOut()
      }
    },
    resetAutoLogout() {
      if (this.autoLogoutObserver) {
        this.autoLogoutObserver
          .stop()
          .reset()
          .start()
      }
    }
  }
}
</script>
